<template>
    <div :class="['tab-navigation', 'block fixed bottom-0 z-1 left-0 right-0 small_desktop:hidden', { 'tab-navigation--hidden': !showTabNavigation }]">
        <div :class="['tab-navigation__inner', 'py-3.5 px-8 bg-gray-200 border-t border-gray-300']">
            <ul class="flex justify-between">
                <li
                    v-for="(item, index) in itensNav"
                    :key="index"
                    :class="{ active: $route.name === item.routeName }"
                    class="tab-navigation--item text-center"
                >
                    <router-link
                        :to="{ name: item.routeName }"
                        class="text-none flex flex-col items-center"
                    >
                        <BaseIcon
                            :icon-name="item.iconName"
                            icon-color="#5A5751"
                        >
                            <component :is="item.iconName" />
                        </BaseIcon>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
// // Icons
import BaseIcon from '@/icons/BaseIcon';
import IconHome from '@/icons/IconHome';
import IconBanner from '@/icons/IconBanner';
import IconMarketing from '@/icons/IconMarketing';
import IconMoney from '@/icons/IconMoney';
import { mapGetters } from 'vuex';

export default {
    name: 'TabNavigation',

    components: {
        BaseIcon,
        IconHome,
        IconBanner,
        IconMoney,
        IconMarketing,
    },

    data: () => ({
        showTabNavigation: true,
        lastScrollPosition: 0,
    }),

    computed: {
        ...mapGetters({
            userIsAffiliate: 'profile/userIsAffiliate',
            userIsSpecialist: 'profile/userIsSpecialist',
        }),

        itensNav() {
            let itens = [
                {
                    iconName: 'icon-home',
                    routeName: 'home',
                    labelText: 'Página Inicial',
                },
                {
                    iconName: 'icon-marketing',
                    routeName: 'affiliate.home',
                    labelText: 'Especialista',
                },
                {
                    iconName: 'icon-banner',
                    routeName: 'specialist.home',
                    labelText: 'Afiliado',
                },
            ];

            if (this.userIsAffiliate || this.userIsSpecialist) {
                itens.push({
                    iconName: 'icon-money',
                    routeName: 'commission',
                    labelText: 'Comissão',
                });
            }

            return itens;
        },
    },

    mounted() {
        window.addEventListener('scroll', this.onScroll);
    },

    beforeUnmount() {
        window.removeEventListener('scroll', this.onScroll);
    },

    methods: {
        onScroll() {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;

            if (currentScrollPosition < 0) {
                return;
            }
            // Stop executing this function if the difference between
            // current scroll position and last scroll position is less than some offset
            if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 5) {
                return;
            }

            this.showTabNavigation = currentScrollPosition < this.lastScrollPosition;
            this.lastScrollPosition = currentScrollPosition;
        },
    },
};
</script>

<style lang="scss" scoped>
html.slide-nav-active .tab-navigation {
    transform: translate3d(0, 100%, 0) !important;
}

.tab-navigation {
    transform: translate3d(0, 0, 0);
    transition: 0.1s all ease-out;

    &--item {
        width: 48px;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
    }

    &.tab-navigation--hidden {
        transform: translate3d(0, 100%, 0);

        .tab-navigation__inner {
            box-shadow: unset;
        }
    }
}

.tab-navigation--item.active {
    background-color: theme('colors.gray.300');
}
</style>
